import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.VUE_APP_SUPABASE_URL
const SUPABASE_KEY = process.env.VUE_APP_SUPABASE_KEY

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY)